import { render, staticRenderFns } from "./edit-logs.vue?vue&type=template&id=fc833210&"
import script from "./edit-logs.vue?vue&type=script&lang=js&"
export * from "./edit-logs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports